import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

import { Typography } from "@mui/material";
import { ResetPasswordContainer, ResetPasswordStyledCard } from '../../Styles/Authentication/authenticationStyles';

import { IconEye, IconEyeOff } from '@tabler/icons-react';

import { useAuthenticationHook } from '../../Hooks/Authentication/authenticationHooks';

import { SignUpUser, Authentication } from '../../Models/Authentication/Authentication';

import LocalStorageHelper from '../../Utilities/Helpers/LocalStorageHelper';
import RequiredParametersHelper from '../../Utilities/Helpers/RequiredParametersHelper';
import RequiredFieldHelper from '../../Utilities/Helpers/RequiredFieldHelper';
import RouteHelper from '../../Utilities/Helpers/RouteHelper';

import { CachingEnum } from '../../Utilities/Enums/CachingEnum';
import { RouteEnum } from '../../Utilities/Enums/RouteEnums';
import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { ActiveStatusEnum } from '../../Utilities/Enums/StatusEnums';
import { AdminUserField, AuthenticationField } from '../../Utilities/Enums/ParametersEnum';

import { ErrorMessage } from '../../Constants/Messages';
import { AssetImages } from "../../Constants/Assets";
import { StaticDisplayText } from '../../Constants/StaticDisplayTexts';

import CustomButton from '../../CustomViews/Elements/CustomButton';
import FormTextField from '../../CustomViews/Elements/FormTextField';

import AuthFooter from './AuthFooter';

export default function ResetPassword() {
    const navigate = useNavigate();
    const { resetPasswordById } = useAuthenticationHook();
    const { enqueueSnackbar } = useSnackbar();
    let requiredFields = RequiredParametersHelper.resetPassword();
    let userData: Authentication = LocalStorageHelper.getUserData();

    //Use States
    let [formData, setformData] = useState<any>({ [AdminUserField.NEW_PASSWORD]: null, [AdminUserField.PASSWORD]: null, [AdminUserField.CONFIRM_PASSWORD]: null });
    let [errorMessages, setErrorMessages]: any = useState({});
    const [showPassword, setShowPassword] = useState(false);

    //Variables
    const newPasswordProps = {
        name: AdminUserField.PASSWORD,
        title: 'New Password',
        fieldValue: formData?.[AdminUserField.PASSWORD] ?? "",
        type: (showPassword ? 'text' : 'password'),
        hasIcon: true,
        iconPosition: 'end',
        icon: (showPassword ? <IconEyeOff /> : <IconEye />),
        required: requiredFields?.find((field: any) => field.keyName == AdminUserField.PASSWORD)?.keyName != null,
        errorMessages: errorMessages,
        onClickIconTrigger: () => {
            setShowPassword(!showPassword);
        },
        handleOnChange: (selectedValue: any) => {
            setformData((prev: any) => ({ ...prev, [AdminUserField.NEW_PASSWORD]: selectedValue, [AdminUserField.PASSWORD]: selectedValue }));
        },
    },
        confirmNewPasswordProps = {
            name: AdminUserField.CONFIRM_PASSWORD,
            title: 'Confirm Password',
            fieldValue: formData?.[AdminUserField.CONFIRM_PASSWORD] ?? "",
            type: (showPassword ? 'text' : 'password'),
            hasIcon: true,
            iconPosition: 'end',
            icon: (showPassword ? <IconEyeOff /> : <IconEye />),
            required: requiredFields?.find((field: any) => field.keyName == AdminUserField.CONFIRM_PASSWORD)?.keyName != null,
            errorMessages: errorMessages,
            onClickIconTrigger: () => {
                setShowPassword(!showPassword);
            },
            handleOnChange: (selectedValue: any) => {
                setformData((prev: any) => ({ ...prev, [AdminUserField.CONFIRM_PASSWORD]: selectedValue }));
            },
        };
    
    //Event Handlers
    const handleSubmit = async () => {
        let _validateForm = RequiredFieldHelper.validateForm(requiredFields, formData, errorMessages, setErrorMessages, enqueueSnackbar);

        if (_validateForm?.hasError) { return true; }

        if(requiredFields?.find((field: any) => field.keyName == AdminUserField.PASSWORD)?.keyName != null && formData?.[AdminUserField.NEW_PASSWORD] != formData?.[AdminUserField.CONFIRM_PASSWORD]) {
            enqueueSnackbar(ErrorMessage.PASSWORD_AND_CONFIRM_PASSSWORD_NOT_MATCH, { variant: 'error' });
            return true;
        }

        let _success: boolean = false;

        if(userData?.[AuthenticationField.PUBLIC_ID] != null && userData?.[AuthenticationField.PUBLIC_ID] != "") {
            let resetPasswordResponse = await resetPasswordById(userData?.[AuthenticationField.PUBLIC_ID], JSON.stringify(formData));
            _success = resetPasswordResponse?.isSuccess ?? false;
        }

        if(_success) {
            LocalStorageHelper.saveUserData({ ...userData, [AuthenticationField.MUST_CHANGE_PASSWORD]: false });
            LocalStorageHelper.saveUpdateUserProfile(true);

            navigate(RouteEnum.DASHBOARD, { replace: true });
        }
    }

    useEffect(() => {
        if(!userData?.[AuthenticationField.MUST_CHANGE_PASSWORD]) {
            navigate(RouteEnum.DASHBOARD, {replace: true});
        }
    }, []);

    //Rendering Functions
    return <ResetPasswordContainer className='glossy-box'>
        <div className="resetPasswordBgContainer">
            <ResetPasswordStyledCard elevation={3}>
                <div className="resetPasswordFormContainer">
                    <div className="formContainer">
                        <img src={AssetImages.WEB_APP_LOGO} />
                        <Typography color="primaryText" className="headerText">{RouteHelper.getRouteDescription(RouteEnum.RESET_PASSWORD)}</Typography>
                        <Typography color="primaryText" className="subHeaderText">Kindly reset your password to proceed</Typography>

                        <div className="fieldsContainer">
                            <FormTextField {...newPasswordProps} />
                            <FormTextField {...confirmNewPasswordProps} />
                        </div>

                        <CustomButton
                            btnType={ButtonType.PRIMARY}
                            title='Update Password'
                            className="submitBtn"
                            onClick={(e: any) => {
                                handleSubmit();
                            }} />

                        <div className="goBackLink" onClick={() => {
                            LocalStorageHelper.clearLocalStorage();

                            navigate(RouteEnum.LOGOUT, { replace: true });
                        }}>Logout</div>

                        {/*<CustomButton
                            btnType={ButtonType.PRIMARY}
                            title='Logout'
                            className="submitBtn"
                            onClick={(e: any) => {
                                LocalStorageHelper.clearLocalStorage();

                                navigate(RouteEnum.LOGOUT, { replace: true });
                            }} />*/}
                    </div>

                    <div className="spacer2" />
                    
                    <AuthFooter />
                </div>
            </ResetPasswordStyledCard>
        </div>
    </ResetPasswordContainer>
}